import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa'; // Import the arrow-up icon from react-icons library

const HomeButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <button
      className={`group fixed bottom-6 right-6 md:bottom-8 md:right-8 z-30 transition-all duration-300 ${
        isVisible 
          ? 'opacity-100 pointer-events-auto translate-y-0' 
          : 'opacity-0 pointer-events-none translate-y-8'
      }`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <div className="relative">
        {/* Main button */}
        <div className="bg-gradient-to-r from-primary-400 to-primary-500 hover:from-primary-500 hover:to-primary-600 text-neutral-900 p-3 md:p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform group-hover:scale-110 group-hover:-translate-y-1">
          <FaArrowUp className="w-5 h-5 md:w-6 md:h-6 group-hover:animate-bounce" />
        </div>
        
        {/* Ripple effect on hover */}
        <div className="absolute inset-0 bg-primary-400 rounded-full opacity-0 group-hover:opacity-20 group-hover:animate-ping"></div>
        
        {/* Subtle glow */}
        <div className="absolute inset-0 bg-primary-400 rounded-full blur-xl opacity-0 group-hover:opacity-30 transition-opacity duration-300"></div>
      </div>
    </button>
  );
};

export default HomeButton;